<div class="card log-execucao-integracao-container">
    <div class="flex align-items-center justify-content-between mb-3 log-execucao-integracao-header">
        <div>
            <h5 class="p-m-0">Log de Execução de Integração</h5>
            <small class="p-text-secondary">Visualize os logs de execução de integrações do sistema.</small>
        </div>
    </div>

    <!-- Filtros -->
    <div class="p-card mb-3">
        <div class="p-card-body">
            <div class="p-fluid grid">
                <div class="field field-label-top col-12 md:col-3">
                    <label for="estacao">Estação</label>
                    <p-dropdown inputId="estacao" appendTo="body" [options]="dropDownEstacoes"
                        [(ngModel)]="estacaoSelecionada" [filter]="true" filterLocale="pt-BR"
                        filterPlaceholder="Pesquisar estação" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-3">
                    <label for="integracao">Integração</label>
                    <p-dropdown inputId="integracao" appendTo="body" [options]="dropDownIntegracoes"
                        [(ngModel)]="integracaoSelecionada" [filter]="true"
                        filterPlaceholder="Pesquisar integração" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="status_code">Status Code</label>
                    <p-dropdown inputId="status_code" appendTo="body" [options]="dropDownStatusCodes"
                        [(ngModel)]="statusCodeSelecionado" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="data_inicio">Data Início</label>
                    <p-datepicker inputId="data_inicio" [(ngModel)]="dataInicio"
                        dateFormat="dd/mm/yy" [showIcon]="true"
                        [maxDate]="dataFim" placeholder="Data Início" styleClass="w-full"
                        appendTo="body" [baseZIndex]="10000">
                    </p-datepicker>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="data_fim">Data Fim</label>
                    <p-datepicker inputId="data_fim" [(ngModel)]="dataFim"
                        dateFormat="dd/mm/yy" [showIcon]="true"
                        [minDate]="dataInicio" placeholder="Data Fim" styleClass="w-full"
                        appendTo="body" [baseZIndex]="10000">
                    </p-datepicker>
                </div>

                <div class="field col-12 md:col-2 flex align-items-end">
                    <button pButton pRipple type="button" label="Filtrar" icon="pi pi-search"
                        class="p-button-primary" (click)="filtrar()" [loading]="loading">
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Grid -->
    <div class="log-execucao-integracao-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="perPage" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id" [loading]="loading"
            [lazy]="true" (onLazyLoad)="onPageChange($event)"
            [totalRecords]="totalRecords" [first]="first"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['estacao.descricao', 'integracao.descricao', 'mensagens', 'status_code', 'data_hora']"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between p-flex-wrap">
                <div class="flex align-items-center p-flex-wrap">
                    <h5 class="p-m-0" style="margin-right: 30px;">Logs de Execução de Integração</h5>
                </div>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>Data/Hora</th>
                <th>Estação</th>
                <th>Integração</th>
                <th>Status Code</th>
                <th>Mensagens</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>
                    <span class="p-column-title negrito">Data/Hora: </span>
                    {{formatarDataHora(item.data_hora)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Estação: </span>
                    {{getNomeEstacao(item)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Integração: </span>
                    {{getNomeIntegracao(item)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Status Code: </span>
                    <span *ngIf="item.status_code === '200'" class="p-badge p-badge-success">{{item.status_code}}</span>
                    <span *ngIf="item.status_code && item.status_code !== '200' && isStatusWarning(item.status_code)" class="p-badge p-badge-warning">{{item.status_code}}</span>
                    <span *ngIf="item.status_code && item.status_code !== '200' && isStatusError(item.status_code)" class="p-badge p-badge-danger">{{item.status_code}}</span>
                    <span *ngIf="item.status_code && item.status_code !== '200' && !isStatusWarning(item.status_code) && !isStatusError(item.status_code)" class="p-badge">{{item.status_code}}</span>
                    <span *ngIf="!item.status_code">-</span>
                </td>
                <td>
                    <span class="p-column-title negrito">Mensagens: </span>
                    {{item.mensagens || 'N/A'}}
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" style="text-align: center;">
                    Nenhum log encontrado. Aplique os filtros para buscar logs.
                </td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

<p-toast></p-toast>
